import { apiPostRequest } from "src/utils/ApiPostRequest";
import { ApiGatewayBaseUrl, routes } from "src/data/Routes";

const getBaseUrl = () => {
    return process.env.NODE_ENV === 'production' ? ApiGatewayBaseUrl.prod : ApiGatewayBaseUrl.beta;
};

export const getCarrierPresignedUrl = async (fileName: string, region: string) => {
    const payload = {
        objectKey: `${fileName}-${Date.now()}`,
        region: region
    };

    const url = `${getBaseUrl()}${routes.carrierAccountSafelisting.uploadCarrierFile}`;

    const response = await apiPostRequest(url, payload);

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Failed to get presigned URL');
    }

    return await response.json();
};

export const uploadFileToS3 = async (presignedUrl: string, file: File) => {
    const response = await fetch(presignedUrl, {
        method: 'PUT',
        body: file,
        headers: {
            'Content-Type': file.type
        }
    });

    if (!response.ok) {
        const error = await response.text();
        throw new Error(error ||'Failed to upload file to S3');
    }

    return response;
};
